import { Component, inject, input } from '@angular/core';
import { Swiper as SwiperCore, Navigation, Grid } from 'swiper';
import { MainHeaderComponent } from '@/main/main-header/main-header.component';
import { SwiperModule } from 'swiper/angular';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@/modules/shared/pipes/pipes.module';
import { OfferBoxMobileHighlightComponent } from '@/main/offer-boxes/offer-box-mobile-highlight/offer-box-mobile-highlight.component';
import { MainService } from '@/main/services/main.service';
import { HIGHLIGHTED_SWIPER_CONFIG } from '@/main/sections/swiper-sections.config';
import { MainLoaderComponent } from '@/main/main-loader/main-loader';

SwiperCore?.use([Navigation, Grid]);

@Component({
	selector: 'app-main-highlighted',
	templateUrl: './main-highlighted.component.html',
	standalone: true,
	imports: [
		MainHeaderComponent,
		SwiperModule,
		CommonModule,
		PipesModule,
		OfferBoxMobileHighlightComponent,
		MainLoaderComponent,
	],
})
export class MainHighlightedComponent {
	readonly query = input.required<string>();
	readonly title = input.required<string>();
	readonly titleSuffix = input.required<string>();

	readonly mainService = inject(MainService);

	readonly offerList$ = this.mainService.fetchOfferListFromQuery$(this.query);

	readonly swiperConfig = HIGHLIGHTED_SWIPER_CONFIG;
}
